export function rgMask(value: string): string {
  if (!value) return value

  const cleanValue = value.replace(/[^a-zA-Z0-9]/g, '').toUpperCase()

  if (/^\d{8}[\dX]$/.test(cleanValue)) {
    return cleanValue.replace(/(\d{2})(\d{3})(\d{3})([\dX])/, '$1.$2.$3-$4')
  }

  if (/^\d{11}$/.test(cleanValue)) {
    return cleanValue.replace(/(\d{3})(\d{3})(\d{3})(\d{2})/, '$1.$2.$3-$4')
  }

  return value
}

export function clearRgMask(value: string): string {
  if (!value) return value
  return value.replace(/[^a-zA-Z0-9]/g, '').toUpperCase()
}
